import {PaybackPageVO, useQueryPaybackPage} from "@/service/payback.s";
import React, {FC} from "react";
import {ProTable} from "@/widget/ProTable/ProTable";
import {GridColDef} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import {formatTime} from "@/helper/method";
import {PaybackPO} from "@/model/finance";

export interface PaybackTableProps {
    customerId?: number;
    contractId?: number;
    enabled?: boolean;
    data?: PaybackPO[];
}

export const PaybackTable: FC<PaybackTableProps> = ({customerId, contractId, enabled = true, data}) => {
    const {
        mutate: paybackPageMutate,
        data: paybackPageData,
        isPending: paybackPagePending,
    } = useQueryPaybackPage()

    const paybackColumns: GridColDef<PaybackPageVO>[] = [
        {
            field: "productName",
            headerName: "业务内容",
            flex: 0.4,
        },
        {field: "paymentMethod", headerName: "回款方式", flex: 0.4},
        {
            field: "flag",
            headerName: "是否收款",
            flex: 0.4,
            valueFormatter: value => value == 1 ? '已收款' : '未收款'
        },
        {
            field: "paymentMoney",
            headerName: "回款金额",
            flex: 0.4,
            renderCell: ({row}) => <Box color={'red'} component={'span'}>{`￥${row.paymentMoney}`}</Box>
        },
        {
            field: "paymentDate",
            headerName: "回款时间",
            headerAlign: "center",
            align: "center",
            valueFormatter: (value) => formatTime("D", value) || "-",
            flex: 0.4,
        }]

    return <ProTable<PaybackPageVO> checkboxSelection={false} autoHeight={false} columnHeaderHeight={40} loading={paybackPagePending}
                                    onSearch={(params) => enabled && paybackPageMutate({...params, customerId, contractId})}
                                    data={paybackPageData?.data} pageSize={5} showToolbar={false}
                                    columns={paybackColumns} source={{
        dataSource: {
            getRows: async () => {
                return {rows: data || [], rowCount: data?.length}
            }
        }, rowCount: data?.length || 0
    }}/>
}